import React from 'react';

export default function Hero({ t, lang, setLang, onOpenFullscreenChat }) {
  const handleToggleLang = () => {
    const list = ['English', 'Tamil', 'Hindi', 'Telugu', 'Kannada', 'Malayalam', 'Arabic'];
    const next = list[(list.indexOf(lang) + 1) % list.length];
    setLang(next);
  };

  return (
    <header id="hero" className="hero-section">
      <div className="container">
        <h1 className="hero-title" dangerouslySetInnerHTML={{ __html: t.heroTitle }} />

        <p className="hero-subtitle">{t.heroSubtitle}</p>

        <div className="hero-ctas">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              if (onOpenFullscreenChat) {
                onOpenFullscreenChat();
              } else {
                document.getElementById('aiAssistantSection')?.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            <span>💬</span>
            <span>{t.btnTrySimulator}</span>
          </button>

          <a href="#recipesSection" className="btn btn-saffron">
            <span>🍲</span>
            <span>{t.btnExploreRecipes}</span>
          </a>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">150+</div>
            <div className="stat-label">{t.statRecipes}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">5</div>
            <div className="stat-label">{t.statStates}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">7</div>
            <div className="stat-label">{t.statLanguages}</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">100%</div>
            <div className="stat-label">{t.statPortions}</div>
          </div>
        </div>
      </div>
    </header>
  );
}
